import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { Score } from '../../models/score.model';
import {
	clearScoresXLSXUrl,
	fetchScoresStart,
	fetchScoresXLSXUrlStart,
} from '../../state/organizations.actions';
import {
	selectOrgLoading,
	selectScores,
	selectScoreXlsxUrl,
} from '../../state/organizations.selector';

@Component({
	selector: 'app-score',
	styleUrls: ['./score.component.scss'],
	templateUrl: './score.component.html',
})
export class ScoreComponent implements OnInit, OnDestroy {
	disableSearchBtn: boolean = true;
	downloading: boolean = false;

	inputId = `${Math.random()}`;

	loading$: Observable<boolean>;
	orgId: string = '';
	scores$: Observable<Score[]>;
	searchButton: boolean = true;
	searchForm: UntypedFormGroup;

	private readonly unsubscribe$: Subject<void> = new Subject();

	constructor(
		private readonly fb: UntypedFormBuilder,
		private readonly router: Router,
		private readonly store: Store,
	) {
		this.searchForm = this.fb.group({
			term: [null],
		});
		this.loading$ = this.store.select(selectOrgLoading);
		this.scores$ = this.store.select(selectScores);
	}

	downloadXlsx(url: string): void {
		const a = document.createElement('a');
		a.href = url;
		a.download = 'scores.xlsx';
		a.click();
		a.remove();
		this.downloading = false;
	}

	getScoreList(hideSearchBtn: boolean = false): void {
		const searchObj = this.searchForm.value;
		this.searchButton = !hideSearchBtn;
		this.store.dispatch(fetchScoresStart({ search: searchObj.term }));
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	ngOnInit(): void {
		this.store
			.select(selectScoreXlsxUrl)
			.pipe(takeUntil(this.unsubscribe$))
			.subscribe((url) => {
				if (url) {
					this.downloadXlsx(url);
					this.store.dispatch(clearScoresXLSXUrl());
				}
			});
		this.store.dispatch(fetchScoresStart({ search: null }));
	}

	onClearSearch(): void {
		this.searchForm.patchValue({ sort: 'asc', term: null });
		this.getScoreList();
		this.searchButton = true;
		this.disableSearchBtn = true;
	}

	onDownloadXlsx(): void {
		this.downloading = true;
		this.store.dispatch(fetchScoresXLSXUrlStart());
	}

	onSearchKeyUp(evt: KeyboardEvent): void {
		const term = this.searchForm.get('term')!.value;

		if (evt.key === 'Enter' && term?.length) {
			this.getScoreList(true);
		} else {
			if (term?.length) {
				this.searchButton = true;
				this.disableSearchBtn = false;
			} else {
				this.disableSearchBtn = true;
			}
		}
	}
}
